"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayParticipantEntryToJSON = exports.GiveawayParticipantEntryFromJSONTyped = exports.GiveawayParticipantEntryFromJSON = exports.instanceOfGiveawayParticipantEntry = void 0;
var runtime_1 = require("../runtime");
var EntityMetadata_1 = require("./EntityMetadata");
/**
 * Check if a given object implements the GiveawayParticipantEntry interface.
 */
function instanceOfGiveawayParticipantEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "participantId" in value;
    return isInstance;
}
exports.instanceOfGiveawayParticipantEntry = instanceOfGiveawayParticipantEntry;
function GiveawayParticipantEntryFromJSON(json) {
    return GiveawayParticipantEntryFromJSONTyped(json, false);
}
exports.GiveawayParticipantEntryFromJSON = GiveawayParticipantEntryFromJSON;
function GiveawayParticipantEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'participantId': json['participantId'],
        'metadata': !(0, runtime_1.exists)(json, 'metadata') ? undefined : (0, EntityMetadata_1.EntityMetadataFromJSON)(json['metadata']),
    };
}
exports.GiveawayParticipantEntryFromJSONTyped = GiveawayParticipantEntryFromJSONTyped;
function GiveawayParticipantEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'participantId': value.participantId,
        'metadata': (0, EntityMetadata_1.EntityMetadataToJSON)(value.metadata),
    };
}
exports.GiveawayParticipantEntryToJSON = GiveawayParticipantEntryToJSON;
